import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import {
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../../localization'
import { ComlogData } from '../../../types/monitoring'
import useStyles from './styles/MonitoringFormListTableHead.styles'

interface MonitoringFormListTableHeadDesktopProps {
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      comLogs: ComlogData
    }>
  >
}
const MonitoringFormListTableHeadDesktop: React.FC<
  MonitoringFormListTableHeadDesktopProps
> = ({ refetch }) => {
  const classes = useStyles()
  const theme = useTheme()

  const isBigScreen = useMediaQuery(theme.breakpoints.up(1600))

  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1" align="left">
          {getTranslate('Date')}
        </Typography>
      </div>
      <div>
        <Typography variant="body1" align="left">
          {getTranslate('User ID')}
        </Typography>
      </div>
      <div>
        <Typography variant="body1" align="left">
          {getTranslate('User IP')}
        </Typography>
      </div>
      <div>
        {isBigScreen ? (
          <Typography variant="body1" align="left">
            {getTranslate('Request Method')}
          </Typography>
        ) : (
          <Tooltip placement="top" title={getTranslate('Request Method')}>
            <Typography variant="body1" align="left">
              {isBigScreen
                ? getTranslate('Request Method')
                : getTranslate('R.Method')}
            </Typography>
          </Tooltip>
        )}
      </div>
      <div>
        <Typography variant="body1" align="left">
          {getTranslate('Endpoint Name')}
        </Typography>
      </div>
      <div>
        <Typography variant="body1" align="left">
          {getTranslate('Endpoint URL')}
        </Typography>
      </div>
      <div>
        <Typography variant="body1" align="left">
          {getTranslate('Status')}
        </Typography>
      </div>
      <div>
        <IconButton onClick={() => refetch()}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}
export default MonitoringFormListTableHeadDesktop
